module.exports = {
  defaultTitle: 'Sebastian White',
  logo: 'https://avatars.githubusercontent.com/u/43759131?s=60&v=4',
  author: 'Sebastian White',
  url: 'https://portfolio.smakosh.com',
  legalName: 'Sebastian White',
  defaultDescription: 'I’m Sebastian and I’m a fullstack web engineer!',
  socialLinks: {
    github: 'https://github.com/swhite21',
    linkedin: 'https://www.linkedin.com/in/ss-white/',
    instagram: 'https://www.instagram.com/sebastian_swhite',
  },
  googleAnalyticsID: 'UA-88875900-4',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: 'appId',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2021',
};
